import { EditIcon } from "@root/assets/icons/editIcon";
import DeleteIcon from "@root/assets/icons/delete-02.svg";
import { Flex, IconButton, Image, Text } from "@chakra-ui/react";
import {
  COURSE_STATUS,
  DELETE,
  EDIT,
  getCourseStatus,
  requirementOptions,
} from "@root/constants";
import { formatToShortDate } from "@root/utils/date-helper";
import { ChangeHistoryIcon } from "@root/assets/icons/historyIcon";

export const TableColumns = (
  handleActions: any,
  t: any,
  handleChangeHistoryClick: any
) => {
  return [
    {
      cell: (info: any) => info?.row?.original?.id || "",
      header: t("subsubscriberManagement.userId"),
    },
    {
      cell: (info: any) => (
        <Flex flexDirection={"column"}>
          <Text style={{ textWrap: "wrap" }}>
            {info?.row?.original?.fullName}
          </Text>
          <Text style={{ textWrap: "wrap" }}>{info?.row?.original?.email}</Text>
        </Flex>
      ),
      header: t("subsubscriberManagement.name&Email"),
    },
    {
      cell: (info: any) => {
        return (
          <Text style={{ textWrap: "wrap" }}>
            {info?.row?.original?.subscriber?.companyName || "-"}
          </Text>
        );
      },
      header: t("subsubscriberManagement.companyName"),
    },
    {
      cell: (info: any) => {
        return (
          <Text style={{ textWrap: "wrap" }}>
            {formatToShortDate(info?.row?.original?.createdAt) || ""}
          </Text>
        );
      },
      header: t("subsubscriberManagement.creationDate"),
    },
    {
      header: t("journalistRequests.viewHistory"),
      accessorKey: "viewHistory",
      cell: (info: any) => (
        <Flex w="50%" h="100%" justify="center" align="center">
          <IconButton
            aria-label="View History"
            icon={<ChangeHistoryIcon />}
            size="sm"
            variant="ghost"
            onClick={(e) => {
              e.stopPropagation();
              handleChangeHistoryClick(info?.row?.original?.id);
            }}
          />
        </Flex>
      ),
    },

    {
      cell: (info: any) => (
        <Flex gap={"14px"}>
          {/* <Flex
            gap={"8px"}
            cursor={"pointer"}
            onClick={() => handleActions(EDIT, info?.row?.original)}
          >
            <EditIcon color={"#5C6670"} />
          </Flex> */}
          <Flex
            gap={"8px"}
            cursor={"pointer"}
            onClick={() => handleActions(DELETE, info?.row?.original)}
          >
            <Image src={DeleteIcon} width={18} />
          </Flex>
        </Flex>
      ),
      header: t("tableColumns.actions"),
    },
  ];
};
